<template>
  <div>
    <b-list-group>
      <b-list-group-item v-for="u in userIssues" :key="u.email"
        class="d-flex justify-content-between align-items-center">
        <span class="d-flex justify-content-between">
          <span>{{ u.displayName }}
            <b-link v-for="i in getUserIssues(u.email)" :key="i.jira_key"
              :href="'https://applyit.atlassian.net/browse/' + i.jira_key">
              <b-badge variant="primary" pill>{{ i.jira_key }}</b-badge>
            </b-link>
          </span>
          <!-- <b-list-group horizontal>
            <b-list-group-item>Cras justo odio</b-list-group-item>
            <b-list-group-item>Dapibus ac facilisis in</b-list-group-item>
            <b-list-group-item>Morbi leo risus</b-list-group-item>
          </b-list-group> -->
        </span>
        <b-badge variant="primary" pill>{{ u.issue_count }}</b-badge>
        <!-- -->
      </b-list-group-item>
    </b-list-group>
  </div>
</template>

<script>
import moment from 'moment';
import Services from '@/services';

export default {
  mounted() {
    this.getData();
  },
  props: {},
  data() {
    return {
      loading: true,
      userIssues: [],
      userIssuesVerbose: [],
    };
  },
  methods: {
    getData() {
      this.loading = true;
      Promise.all([
        Services.reports.UserIssues(),
      ]).then(([userIssuesResp]) => {
        // console.log(issuesResp.data, vacationsResp.data);
        this.userIssues = userIssuesResp.data.data;
        this.userIssuesVerbose = userIssuesResp.data.verboseResult;
        this.loading = false;
      });
    },
    getUserIssues(email) {
      return this.userIssuesVerbose.filter((i) => i.email === email).slice(0, 6);
    }
  }
};

// };
</script>
